// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ukyz","badges":"styles_badges__hLAKg"};